<template>
    <div class="typ">{{ item.utbildningstyp }}</div>
    <div class="namn"><a :id="item.utbildningId"
            :href="store.settings.detaljsidaUrl + '?utbildningId=' + item.utbildningId + '&astasearchperiod=' + store.sökParametrar.searchterm + '&astasearchfor=' + store.sökParametrar.searchfor + '&astasearchcategory=' + store.sökParametrar.searchkategori">{{
                item.anmälningsalternativ }}</a></div>
    <div class="text">
        <div class="skolinfo">
            <div class="skola">{{ item.lärosäte }}</div>
            <div class="studieort">Studieort: {{ item.studieort }}</div>
        </div>
        <div class="kod">{{ item.anmälningskod }}</div>
        <div class="omgang">{{ item.antagningsomgångId }}</div>
        <div class="studieikoner">
            <div class="studietakt" :class="studietaktClass" data-toggle="tooltip" data-trigger="hover"
                data-placement="bottom" :data-original-title="'Studietakt: ' + item.studietakt + '%'"
                :aria-label="item.studietakt + '%'"></div>
            <div class="undervisningsform" :class="undervisningsformClass" data-toggle="tooltip" data-trigger="hover"
                data-placement="bottom" :data-original-title="'Undervisningsform: ' + undervisningsformText"
                :aria-label="undervisningsformText"></div>
            <div class="studietid" :class="studietidClass" data-toggle="tooltip" data-trigger="hover"
                data-placement="bottom" :data-original-title="'Studietid: ' + studietidText"
                :aria-label="studietidText"></div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { AstaResultItemType } from '../../types/AstaTypes';
import useAstaStore from '../stores/AstaStore';

const store = useAstaStore();
const props = defineProps<{
    item: AstaResultItemType,
}>();
const studietaktClass = computed(() => {
    let taktKlass = '';
    if (parseInt(props.item.studietakt.trim()) <= 25) {
        taktKlass = 'studietakt_25';
    } else if (parseInt(props.item.studietakt.trim()) <= 50) {
        taktKlass = 'studietakt_50';
    } else if (parseInt(props.item.studietakt.trim()) <= 75) {
        taktKlass = 'studietakt_75';
    } else {
        taktKlass = 'studietakt_100';
    }
    return taktKlass;
});
const undervisningsformClass = computed(() => {
    let undervisningsformKlass = '';
    if (props.item.undervisningsform === 'DST') {
        undervisningsformKlass = 'undervisningsform_DST';
    } else if (props.item.undervisningsform === 'ING') {
        undervisningsformKlass = 'undervisningsform_ING';
    } else if (props.item.undervisningsform === 'ITD') {
        undervisningsformKlass = 'undervisningsform_ITD';
    } else if (props.item.undervisningsform === 'NML') {
        undervisningsformKlass = 'undervisningsform_NML';
    }
    return undervisningsformKlass;
});
const undervisningsformText = computed(() => {
    let undervisningsformText = '';
    if (props.item.undervisningsform === 'DST') {
        undervisningsformText = 'Distans';
    } else if (props.item.undervisningsform === 'ING') {
        undervisningsformText = 'Inga uppgifter';
    } else if (props.item.undervisningsform === 'ITD') {
        undervisningsformText = 'Internetbaserad distansunderv';
    } else if (props.item.undervisningsform === 'NML') {
        undervisningsformText = 'Normal undervisning';
    }
    return undervisningsformText;
});
const studietidClass = computed(() => {
    let studietidKlass = '';
    if (props.item.studietid === 'BLA') {
        studietidKlass = 'studietid_BLA';
    } else if (props.item.studietid === 'DAG') {
        studietidKlass = 'studietid_DAG';
    } else if (props.item.studietid === 'EFT') {
        studietidKlass = 'studietid_EFT';
    } else if (props.item.studietid === 'ING') {
        studietidKlass = 'studietid_ING';
    } else if (props.item.studietid === 'KVÄ') {
        studietidKlass = 'studietid_KVÄ';
    } else if (props.item.studietid === 'VSL') {
        studietidKlass = 'studietid_VSL';
    }
    return studietidKlass;
});
const studietidText = computed(() => {
    let studietidText = '';
    if (props.item.studietid === 'BLA') {
        studietidText = 'Blandad undervisning';
    } else if (props.item.studietid === 'DAG') {
        studietidText = 'Dagtid';
    } else if (props.item.studietid === 'EFT') {
        studietidText = 'Eftermiddag';
    } else if (props.item.studietid === 'ING') {
        studietidText = 'Inga uppgifter';
    } else if (props.item.studietid === 'KVÄ') {
        studietidText = 'Kvällstid';
    } else if (props.item.studietid === 'VSL') {
        studietidText = 'Veckoslut';
    }
    return studietidText;
});

</script>